import {useOutlet} from 'reconnect.js';
import qs from 'query-string';
import {Steps} from 'antd';
import React from 'react';
import * as AppActions from '../../AppActions';
import styled from 'styled-components';
import {withLoginRequired} from 'rev.sdk.js/Components/LoginRequired';
import SiteNavBar from '../SiteNavBar';
import LoginRequired from '../LoginRequired';
import useIsInApp from 'rev.sdk.js/Hooks/useIsInApp';

const L = AppActions.L;

function CheckoutLayout(props) {
  const isInApp = useIsInApp();
  const [actions] = useOutlet('actions');
  const [dimension] = useOutlet('dimension');
  const {style = {}} = props;
  const route = props.location.pathname;
  const params = qs.parse(props.location.search);

  function renderCustomSection(sectionId) {
    const subRoute = route.split('/')[2];
    let current = 0;

    if (subRoute === 'info') {
      current = 1;
    } else if (subRoute === 'review') {
      current = 2;
    }

    if (sectionId === 'B') {
      return (
        <Steps
          direction="horizontal"
          type="navigation"
          responsive={false}
          current={current}
          style={{fontWeight: '300'}}>
          <Steps.Step title={L('cart')} />
          <Steps.Step title={L('checkout_info')} />
          <Steps.Step title={L('payment')} />
        </Steps>
      );
    }

    return null;
  }

  return (
    <Wrapper
      id="rev-checkout-layout"
      isInApp={isInApp}
      rwd={dimension.rwd}
      style={{...style}}>
      {renderCustomSection('A')}

      <div className="content">
        {renderCustomSection('B')}

        {props.children}

        {renderCustomSection('J')}
      </div>

      {renderCustomSection('K')}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: calc(
    ${({isInApp, rwd}) => (isInApp ? '0px' : 'var(--topNavBarHeight)')} +
      ${(props) => (props.rwd === 'mobile' ? '0px' : '30px')}
  );

  & > .content {
    max-width: var(--contentMaxWidth);
    min-height: var(--contentMinHeight);
    margin: 0 auto;

    @media screen and (max-width: 1200px) {
      padding: 30px 50px;
    }
    @media screen and (max-width: 768px) {
      padding: 30px 20px;
    }
  }

  & .ant-steps {
    margin-bottom: 40px;
  }

  & .ant-steps-item .ant-steps-item-icon,
  .ant-steps-item-wait .ant-steps-item-icon {
    font-family: 'kepler-3-display-variable', sans-serif;
    border-radius: 0;
    //background-color: var(--background-reverse-color);
    & > .ant-steps-icon {
      //color: var(--text-reverse-color);
    }
  }
  & .ant-steps-navigation .ant-steps-item::before {
    height: 1px;
    background-color: var(--border-dark-color);
  }
  &.ant-steps-item-title {
    color: var(--text-4-color);
  }

  @media only screen and (max-width: 768px) {
    &#rev-checkout-layout .ant-steps-navigation .ant-steps-item::before,
    &#rev-checkout-layout
      .ant-steps-navigation
      .ant-steps-item
      .ant-steps-item-content {
      display: none;
    }
    & .ant-steps {
      margin-bottom: 10px;
    }
  }
`;

export default withLoginRequired(CheckoutLayout, {
  admin: false,
  SiteNavBar,
  renderLoginRequired: LoginRequired,
});
